enum EntityType {
    Address = 'Address',
    Cluster = 'Cluster',
    Transaction = 'Transaction'
}

export {EntityType}